"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_1 = require("../extension");
const escaper_1 = require("../node-visitor/escaper");
const auto_escape_1 = require("../token-parser/auto-escape");
const file_extension_escaping_strategy_1 = require("../file-extension-escaping-strategy");
const filter_1 = require("../filter");
class TwingExtensionEscaper extends extension_1.TwingExtension {
    /**
     * @param {string} defaultStrategy An escaping strategy
     */
    constructor(defaultStrategy = 'html') {
        super();
        this.setDefaultStrategy(defaultStrategy);
    }
    getTokenParsers() {
        return [
            new auto_escape_1.TwingTokenParserAutoEscape()
        ];
    }
    getNodeVisitors() {
        return [
            new escaper_1.TwingNodeVisitorEscaper()
        ];
    }
    getFilters() {
        return new Map([
            [0, new filter_1.TwingFilter('raw', twingRawFilter, {
                    is_safe: ['all']
                })],
        ]);
    }
    /**
     * Sets the default strategy to use when not defined by the user.
     *
     * The strategy can be a valid PHP callback that takes the template
     * name as an argument and returns the strategy to use.
     *
     * @param {string|boolean|Function} defaultStrategy An escaping strategy
     */
    setDefaultStrategy(defaultStrategy) {
        if (defaultStrategy === 'name') {
            defaultStrategy = file_extension_escaping_strategy_1.TwingFileExtensionEscapingStrategy.guess;
        }
        this.defaultStrategy = defaultStrategy;
    }
    /**
     * Gets the default strategy to use when not defined by the user.
     *
     * @param {string|boolean} name The template name
     *
     * @returns {string|false} The default strategy to use for the template
     */
    getDefaultStrategy(name) {
        let result;
        // disable string callables to avoid calling a function named html or js,
        // or any other upcoming escaping strategy
        if (typeof this.defaultStrategy === 'function') {
            return this.defaultStrategy(name);
        }
        result = this.defaultStrategy;
        return result;
    }
}
exports.TwingExtensionEscaper = TwingExtensionEscaper;
/**
 * Marks a variable as being safe.
 *
 * @param {string} string A variable
 *
 * @return string
 */
function twingRawFilter(string) {
    return string;
}
exports.twingRawFilter = twingRawFilter;
